/* Alternate templates are scoped to this unpublished preview. Product and Page
   template assignments stay unchanged on the current live store. */
(function () {
  function start() {
    if (!window.Shopify || !Shopify.theme || Shopify.theme.role !== 'unpublished') return;
    var views = {
      '/products/realshare-pack-exclusif': 'realshare',
      '/products/clitoshare-pack-exclusif': 'clitoshare',
      '/pages/notre-histoire': 'histoire',
      '/pages/customer-care': 'customer-care',
      '/pages/politique-de-retour-et-de-remboursement': 'returns',
      '/pages/manuel-utilisateur': 'manuel-utilisateur',
      '/pages/politique-de-confidentialite': 'privacy'
    };
    function decorate(link) {
      if (!link || !link.hasAttribute('href')) return;
      var url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      var path = url.pathname.replace(/^\/(?:en|es)(?=\/|$)/, '').replace(/\/$/, '');
      if (!views[path] || url.searchParams.has('view')) return;
      url.searchParams.set('view', views[path]);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
    document.querySelectorAll('a[href]').forEach(decorate);
    document.addEventListener('click', function (event) {
      decorate(event.target.closest && event.target.closest('a[href]'));
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
